import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { useModuleVariable } from "2g-modules-provider";

import { useZakaznik } from "b2b/api/hooks";

export default function useZakaznikDetail({ ico }) {
  const loader = useZakaznik({ ico });
  const history = useHistory();
  const [, setSmlouvyWidget] = useModuleVariable(
    "collapsed",
    "smlouvyGrid.grid.resultWidget"
  );
  const [, setProjektyWidget] = useModuleVariable(
    "collapsed",
    "projektyGrid.grid.resultWidget"
  );

  useEffect(() => {
    const openGrid = history.location.state?.openGrid;
    if (openGrid === "smlouvy") {
      setTimeout(() => {
        setSmlouvyWidget(false);
      }, 500);
    }
    if (openGrid === "projekty") {
      setTimeout(() => {
        setProjektyWidget(false);
      }, 500);
    }
  }, [history.location.pathname]);

  return { zakaznik: loader.data, ...loader };
}
